'use client'

import { useSyncExternalStore } from 'react'

export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (notify) => {
      const mql = window.matchMedia(query)
      mql.addEventListener('change', notify)
      return () => {return mql.removeEventListener('change', notify)}
    },
    () => {return window.matchMedia(query).matches},
    () => {return false},
  )
}

export const useReducedMotion = () =>
  {return useMediaQuery('(prefers-reduced-motion: reduce)')}
